import React, { useState, useEffect } from "react";
import Markdown from "markdown-to-jsx";
import Header from "../components/layouts/Header";

function PaperDetails(props) {
    const [content, setContent] = useState("");
    const paperId = props.match.params.id;
    const paperFile = props.match.params.title;

    useEffect(() => {
        import(`../papers/${paperFile}.md`)
            .then((res) => res.default)
            .then((res) => {
                fetch(res)
                    .then((result) => result.text())
                    .then((result) => setContent(result));
            });
    }, [content, paperFile]);

    const [toggleMenu, setToggleMenu] = useState(false);

    const headerToggler = (e) => {
        e.preventDefault();
        setToggleMenu(!toggleMenu);
    };

    document.addEventListener("click", function (e) {
        if (e.target.closest(".content")) {
            setToggleMenu(false);
        }
    });

    //document.body.classList.add("dark");
    //Uncomment the above line if you use dark version

    return (
        <>
            <Header
                light
                logoSource="/images/logo.svg"
                toggleMenu={toggleMenu}
                headerToggler={headerToggler}
            />
            <main className={toggleMenu ? "content open" : "content"}>
                <div className="spacer" data-height="96"></div>
                <div className="blog-page-section">
                    <div className="container">
                        <div className="blog-single shadow-dark p-30">
                            <Markdown>{content}</Markdown>
                        </div>
                    </div>
                </div>
                <div className="spacer" data-height="96"></div>
            </main>
        </>
    );
}

export default PaperDetails;
